import type { Sport } from '@sharpr/types';
import { SPORT_LABELS } from '@/utils/sportIcons';

/** Display name for a sport code — delegates to SPORT_LABELS. */
export function getSportName(sport: Sport): string {
  return SPORT_LABELS[sport];
}
